import React from 'react';
import useLaunchProjectNavigator from './launchProjectNavigator';

export default function ProjectIsArchivedMessage() {

  const navigator = useLaunchProjectNavigator();

  const link = (
    /* eslint-disable jsx-a11y/anchor-is-valid */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    <a onClick={() => navigator.openUpdateProjectPage()}>click here</a>
  );

  return (
    <div>
      This property is in an Archived status. To un-archive the property,
      &nbsp;
      {link}
    </div>
  );
}
